var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConcentrate = function SvgConcentrate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#concentrate_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M40.168 18.849a5.518 5.518 0 0 0-7.724-7.882L20.621 22.553a6.62 6.62 0 0 0-1.91 3.727l-.502 3.272-2.364 2.317a1.104 1.104 0 0 0-.016 1.561l1.545 1.576a1.104 1.104 0 0 0 1.56.016l2.365-2.317 3.282-.435a6.62 6.62 0 0 0 3.764-1.835L40.168 18.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m26.2 10.904 13.904 14.188m-17.198 2.947L30 21.087"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m12.739 38.16-2.55 5.1a2.85 2.85 0 0 0 2.55 4.126 2.85 2.85 0 0 0 2.55-4.125l-2.55-5.102Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M41.823 14.964a5.52 5.52 0 0 1-1.655 3.885l-2.254 2.209-7.727-7.88 2.257-2.211a5.518 5.518 0 0 1 9.38 3.997Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "m40.168 18.849.612.625zm1.655-3.885.875.009zm-3.909 6.094-.625.612a.875.875 0 0 0 1.237.013zm-7.727-7.88-.612-.625a.875.875 0 0 0-.012 1.238zm2.257-2.211.612.625zm3.918-1.577-.01.875zm3.885 1.656-.625.612zm.533 8.428a6.4 6.4 0 0 0 1.918-4.501l-1.75-.018a4.64 4.64 0 0 1-1.392 3.269zm-2.254 2.209 2.254-2.21-1.224-1.249-2.254 2.209zm-8.964-7.892 7.727 7.88 1.25-1.226-7.727-7.88zm2.27-3.449-2.257 2.211 1.225 1.25 2.256-2.211zm4.538-1.827a6.4 6.4 0 0 0-4.539 1.827l1.225 1.25a4.64 4.64 0 0 1 3.297-1.327zm4.502 1.918a6.4 6.4 0 0 0-4.502-1.918l-.017 1.75a4.64 4.64 0 0 1 3.269 1.393l1.25-1.224Zm1.826 4.54a6.4 6.4 0 0 0-1.826-4.54l-1.25 1.225a4.64 4.64 0 0 1 1.327 3.297l1.75.018Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "concentrate_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 2h48v48H2z"
  })))));
};
export default SvgConcentrate;